export default "__VITE_ASSET__924742a5__"